var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.00007C15.5004 8.16983 15.4569 8.33682 15.3736 8.48478C15.2904 8.63274 15.1703 8.75665 15.025 8.84444L6.02 14.3532C5.86818 14.4462 5.69429 14.4969 5.5163 14.5002C5.33831 14.5035 5.16266 14.4592 5.0075 14.3719C4.85382 14.286 4.7258 14.1607 4.6366 14.0089C4.54741 13.8571 4.50026 13.6843 4.5 13.5082V2.49194C4.50026 2.31587 4.54741 2.14304 4.6366 1.99124C4.7258 1.83943 4.85382 1.71412 5.0075 1.62819C5.16266 1.54091 5.33831 1.49663 5.5163 1.49993C5.69429 1.50322 5.86818 1.55398 6.02 1.64694L15.025 7.15569C15.1703 7.24349 15.2904 7.36739 15.3736 7.51535C15.4569 7.66332 15.5004 7.8303 15.5 8.00007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume_icon.a69eedf3afb2e3df0ccdcb337395437d.svg";
export { ForwardRef as ReactComponent };